<template>
  <div class="create-account">
    <section id="servicios" class="secciones seccion-blanca formulario">
      <div class="container">
        <template v-if="successMessage != ''">
          <h1>{{ successMessage }}.</h1>
        </template>
        <template v-else>
          <form @submit.prevent="createAccount">
            <h1>
              <strong>Crear Cuenta</strong>
            </h1>
            <br />
            <br />
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-sm-12">
                    <input
                      type="email"
                      class="form-control"
                      v-model="client_email"
                      id="email"
                      placeholder="Dirección de correo electrónico *"
                      minlength="6"
                      title="Ingrese un e-mail válido como: example@example.com"
                      maxlength="255"
                      required
                    />
                    <div class="invalid-feedback">El correo electrónico es requerido.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      placeholder="Contraseña *"
                      value
                      v-model="client_password"
                      maxlength="255"
                      minlength="6"
                      title="Sólo se permiten letras (mayúsculas y minúsculas) y números. Puede ingresar un mínimo de 6 caracteres y un máximo de 255"
                      required
                    />
                    <div class="invalid-feedback">La contraseña es requerida.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      placeholder="Nombre *"
                      v-model="client_name"
                      maxlength="24"
                      minlength="2"
                      required
                    />
                    <div class="invalid-feedback">El nombre es requerido.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      placeholder="Apellido Paterno *"
                      v-model="client_lastname_p"
                      maxlength="24"
                      minlength="2"
                      required
                    />
                    <div class="invalid-feedback">El apellido paterno es requerido.</div>
                  </div>

                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="client_lastname_m"
                      id="lastName"
                      placeholder="Apellido Materno*"
                      maxlength="24"
                      minlength="2"
                      required
                    />
                    <div class="invalid-feedback">El apellido materno es requerido.</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <select class="form-control" v-model="dni_type" name="" id="" required>
                      <option value="0" selected>DNI</option>
                      <option value="1" selected>CE</option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <input
                      type="text"
                      class="form-control"
                      id="dni"
                      :placeholder="dni_type == 0 ? 'DNI *' : 'Carnét de Extranjería *'"
                      maxlength="8"
                      pattern="[0-9]{8}"
                      title="Sólo se permiten números. Debe ingresar un Documento válido."
                      v-model="client_dni"
                      required
                    />
                  </div>

                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      placeholder="Teléfono *"
                      maxlength="11"
                      pattern="[0-9]{7,11}"
                      title="Sólo se permiten números. Debe ingresar un teléfono válido."
                      v-model="cliente_phone"
                      required
                    />
                    <div class="invalid-feedback">El número de teléfono es requerido.</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-md-12">
                    <select
                      v-model="cboDepartamento"
                      id="basicSelect"
                      :plain="true"
                      @change="(event) => callProvincias(cboDepartamento)"
                      class="form-control"
                      required
                    >
                      <option disabled value="">Seleccione Departamento *</option>
                      <option
                        v-for="depa in depas_array"
                        :key="depa.id_departament"
                        :value="depa.id_departament"
                        >{{ depa.desc_departament }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <select
                      v-model="cboProvincia"
                      id="basicSelect"
                      :disabled="isdisabled"
                      required
                      :plain="true"
                      @change="(event) => callDistritos(cboProvincia)"
                      class="form-control"
                    >
                      <option disabled value="">Seleccione Provincia *</option>
                      <option
                        v-for="provincia in province_array"
                        :key="provincia.id_province"
                        :value="provincia.id_province"
                        >{{ provincia.desc_province }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <select
                      v-model="cboDistrito"
                      id="basicSelect"
                      :disabled="isdisabled_distrito"
                      required
                      :plain="true"
                      @change="(event) => enableDireccion()"
                      class="form-control"
                    >
                      <option disabled value="">Seleccione Distrito *</option>
                      <option
                        v-for="distrito in distrito_array"
                        :key="distrito.id_district"
                        :value="distrito.id_district"
                        >{{ distrito.desc_district }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="client_address"
                      id="emailId"
                      placeholder="Dirección *"
                      minlength="10"
                      maxlength="255"
                      required
                      :disabled="isdisabled_direccion"
                      title="El texto debe tener un mínimo de 5 caracteres y un máxmimo de 255"
                    />
                  </div>
                </div>
              </div>
            </div>

            <small
              ><strong
                >SUGERENCIA: Ingrese una contraseña segura incluyendo una combinación de caracteres
                especiales, letras y números.</strong
              ></small
            >
            <br />
            <small><strong>NOTA: Los campos con asterísco (*) son obligatorios.</strong></small>

            <br />
            <br />
            <div class="col-xs-12 text-center  mt-2">
              <button type="submit" class="btn btn-lg btn-primary">
                <i class="fa fa-spinner fa-spin mr-1" v-if="showLoader"></i> Registrar
              </button>
            </div>
          </form>

          <br />
          <div class="col-sm-12">
            <div :class="[successMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
                &times;</button
              ><strong>{{ successMessage }}</strong>
            </div>
            <div :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
                &times;</button
              ><strong>{{ errorMessage }}</strong>
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import toastr from 'toastr';
import axios from 'axios';
import { generateRefreshTokenBodyRequest, setTokens } from '@/helpers/localStorage.helpers';
import { NOT_FOUND, BAD_REQUEST, UNAUTHORIZED, CONFLICT } from '@/types/httpd.constants';
import { successToaster, errorToaster } from './shared/service/ErrorHandler.js';
import { config_settings } from '../config.js';
import { postLogin, postNewAccount } from '@/service/account.service';

export default {
  name: 'CreateAccount',
  created() {
    this.callDepartamentos();
  },
  data() {
    return {
      successMessage: '',
      errorMessage: '',
      showLoader: false,
      client_email: '',
      client_username: '',
      client_password: '',
      client_name: '',
      client_lastname: '',
      client_lastname_p: '',
      client_lastname_m: '',
      client_dni: '',
      cliente_phone: '',
      cboDepartamento: '',
      cboProvincia: '',
      cboDistrito: '',
      client_address: '',
      cboDepartamento: '',
      cboProvincia: '',
      cboDistrito: '',
      client_photo: 'clients/empty-img',
      depas_array: [],
      province_array: [],
      distrito_array: [],
      isdisabled: true,
      isdisabled_distrito: true,
      isdisabled_direccion: true,
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      dni_type: 0,
    };
  },
  methods: {
    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    createAccount() {
      this.showLoader = true;
      var distrito_json = '';
      var direccion_json = ' ';
      var dni_json = ' ';
      var phone_json = ' ';

      this.cboDistrito != ''
        ? (distrito_json = { id_district: this.cboDistrito })
        : (distrito_json = { id_district: null });
      this.client_address != '' ? (direccion_json = this.client_address) : (direccion_json = ' ');
      this.client_dni != '' ? (dni_json = this.client_dni) : (dni_json = null);
      this.cliente_phone != '' ? (phone_json = this.cliente_phone) : (phone_json = null);

      var arrayDeCadenas = this.client_email.split('@');

      var json_data = {
        // "nick_client": this.client_username,
        nick_client: arrayDeCadenas[0],
        dni_client: dni_json,
        name_client: this.client_name,
        surname_client: this.client_lastname_p + ' ' + this.client_lastname_m,
        address_client: direccion_json,
        email_client: this.client_email,
        phone_client: phone_json,
        id_district: distrito_json,
        state: {
          id_state: 2,
        },
        password_client: this.client_password,
        photo_client: this.client_photo,
      };

      postNewAccount(json_data, 'internal')
        .then((response) => {
          // this.createAccount_erp(json_data);
          /*
        toastr.success('Su Usuario ha sido ingresado con éxito.',
                       "ÉXITO", {"iconClass": 'customer-success'});
                       */
          this.successMessage =
            'Estimado usuario, usted ha sido registrado correctamente. Ingrese a su correo electrónico para activar su cuenta';
          this.errorMessage = '';

          /*
                       if(this.client_address != ""){
                          this.agregar_direccion(distrito_json,direccion_json);
                        }
                        this.reset_view();

                        */
        })
        .catch((error) => {
          console.log(error.response.data.details);
          if (error.response.status === CONFLICT) {
            this.errorMessage =
              'El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.';
          } else if (error.response.status === BAD_REQUEST) {
            this.errorMessage = 'Ingrese correctamente los datos solicitados.';
          } else if (error.response.status === NOT_FOUND) {
            this.errorMessage = 'Se ha producido un error. Inténtelo nuevamente.';
          }
          this.successMessage = '';
        });

      this.showLoader = false;
    },

    agregar_direccion(distrito, direccion) {
      var json_data = {
        id_district: { id_district: distrito },
        address: direccion,
        state: { id_state: 1 },
      };

      axios({
        method: 'POST',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/clients-address',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          console.log('DIRECCION REGISTRADA!');
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.agregar_direccion(distrito, direccion);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.errorMessage = 'Debe iniciar sesión antes de continuar';
                this.successMessage = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    reset_view() {
      (this.showLoader = false),
        (this.client_email = ''),
        (this.client_username = ''),
        (this.client_password = ''),
        (this.client_name = ''),
        (this.client_lastname = ''),
        (this.client_lastname_p = ''),
        (this.client_lastname_m = ''),
        (this.client_dni = ''),
        (this.cliente_phone = ''),
        (this.cboDepartamento = ''),
        (this.cboProvincia = ''),
        (this.cboDistrito = ''),
        (this.client_address = ''),
        (this.cboDepartamento = ''),
        (this.cboProvincia = ''),
        (this.cboDistrito = ''),
        (this.isdisabled = true),
        (this.isdisabled_distrito = true),
        (this.isdisabled_direccion = true);
    },

    callDepartamentos() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/locations/departments',
      })
        .then((response) => {
          this.depas_array = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    callProvincias(cboDepartamento) {
      axios({
        method: 'get',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/GET/locations/departaments/' +
          cboDepartamento +
          '/provinces',
      })
        .then((response) => {
          this.province_array = response.data;
          this.cboProvincia = '';
          this.cboDistrito = '';
          this.isdisabled = false;
          this.isdisabled_distrito = true;
          this.txtDireccion = '';
          this.isdisabled_direccion = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    callDistritos(cboProvincia) {
      axios({
        method: 'get',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/GET/locations/departments/provinces/' +
          cboProvincia +
          '/districts',
      })
        .then((response) => {
          this.distrito_array = response.data;
          this.cboDistrito = '';
          this.isdisabled_distrito = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    enableDireccion() {
      this.isdisabled_direccion = false;
    },

    hideMessages() {
      this.successMessage = '';
      this.errorMessage = '';
    },
  },
};
</script>

<style>
.form-signup {
  width: 100%;
  max-width: 500px;
  padding: 15px;
  margin: auto;
}

.hrdivider {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}

.hrdivider span {
  position: absolute;
  top: -11px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  font-size: 16px;
}
</style>
